import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    standalone: false,
})
export class MessageDialogComponent {
    data = inject<{
        message: string;
    }>(MAT_DIALOG_DATA);
}
